import { useDispatch, useSelector } from 'react-redux';

import { setSearchResults, reset, SUPPLIES_SEARCH_LOADING, SUPPLIES_SEARCH_KEYWORD } from './suppliesSearchActions';
import { hawkPayloadToResults } from './util';
import useSearchEndpoint from '../search/useSearchEndpoint';

export default function useSuppliesSearch() {
    const dispatch = useDispatch();
    const [searchApi] = useSearchEndpoint('suppliesfinder');

    const latestSearch = useSelector(state => state.suppliesSearch.latestSearch);
    const setLatestSearch = query => {
        dispatch({ type: SUPPLIES_SEARCH_KEYWORD, latestSearch: query });
    };
    const isLoading = useSelector(state => state.suppliesSearch.loading);
    const setLoading = loading => {
        dispatch({ type: SUPPLIES_SEARCH_LOADING, loading });
    };
    const options = useSelector(state => state.suppliesSearch.options);

    const search = (query, productGroups, extraData) => {
        setLoading(true);
        try {
            searchApi.search({ Keyword: query }).then(({ data }) => {
                setLoading(false);
                const payload = hawkPayloadToResults(data, query, productGroups);
                const results = { key: query, ...payload, banner: data?.Merchandising?.Items?.[0] };
                return dispatch(setSearchResults({ results, keyword: data?.Keyword, options: extraData }));
            });
        } catch (e) {
            setLoading(false);
        }
    };

    const clearResults = () => {
        dispatch(reset());
    };

    const localResults = useSelector(state => state.suppliesSearch.results);

    return {
        search,
        localResults,
        clearResults,
        isLoading,
        setLoading,
        latestSearch,
        setLatestSearch,
        options,
    };
}
